import { casesReducer } from './casesReducer';
import { casesActions } from './casesActions';
import { casesSagas } from './casesSagas';
export default {
    reducer: casesReducer,
    actions: casesActions,
    sagas: casesSagas,
};
